<div>

  <div style="margin: 15px auto;width:80dw; max-width: 1200px; height: 500px; ">
  
      <div style="width: 100%;  padding: 30px 0px;">
        <img src="/assets/flow-studio-logo-90.png" style="display:block; margin: 0px auto;">
        <h3 style='text-align: center;'>Flow Towards Success</h3>
  
        <div style="text-align: center;">Your flows are critical to you, your process and your business. We want to help you keep them that way.</div>
  
      </div>
      <div style="display: flex;">
        <div style="width:20%;"></div>
        <div style="width: 60%; padding-right:5px;">

          <h4 style="color: #ff6358;">Company</h4>

          <div>
            Flow Studio Solutions Pty Ltd.<br>
            ABN 82 632 928 539<br>
            PO BOX 115, <br>
            Lidcombe 1825, <br>
            Sydney, Australia<br>
          </div>

          <h4 style="color: #ff6358;">Privacy and GDPR</h4>
  
          <div style="height: 100px;">The FlowStudio Team (Flow Studio Solutions Pty Ltd., ABN 82 632 928 539) will only share Personal data and Personal Sensitive data between Client and Team with the written consent from both parties.  <br>
            <br>
            Application analytics usage data is tracked via Azure Application Insight.<br>
            <br>
            No data will be shared with other organisations the FlowStudio team is associated with: SharePoint Gurus, Sydney SharePoint Usergroups, Sydney PowerApps & Flow Usergroups or Office 365 Saturday Australia.<br>
            <br>
            Without this written consent, no personal data will be shared with any persons or organisations in or outside of The FlowStudio Team.<br>
            <br>
            All transfer of data within or between The FlowStudio Team and its Customers is protected by HTTPS encryption.  <br>
            <br>            
            Specifically, FlowStudio records a user's Email address for login and verifying valid accounts.  FlowStudio snapshot stores copies of Flow definitions (without the connections), so a maker can revert their Flows to an earlier version.  This is only provided for subscribers.  In the future we may look at implementing a subscription service or automated remote monitoring services - we will send communication before moving users into this offering.<br>
            <br>
            Requests for account to be deleted is available by contacting compliance officer (John Liu) via <a href="mailto:support@flowstudio.app">email support</a><br>
            <br>
            <button kendoButton routerLink="/welcome" [icon]="'arrow-left'" look="flat">Back</button>
          </div>
  
        </div>
        <div style="width:20%;"></div>
      </div>
    </div>

  </div>
